import { FC } from "react";
import { ICard } from "../../../interfaces";

import frontSideAction from "../../../assets/cards/str_card.svg";

interface IStrengthCardReadOnly {
    cardData: ICard;
    isSmall?: boolean;
}
const StrengthCardReadOnly: FC<IStrengthCardReadOnly> = ({ cardData, isSmall }) => {

    if(isSmall){
        return(
            <div className="card_read_only" style={{borderRadius: "0.5vw"}} >
            <img className="front_side_card_read_only_image" src={frontSideAction} alt="front side action" />
            <div className="strength_front_side_card_read_only_content" style={{ paddingTop: "1vw" }}>
                <div className="center_horizontally_and_vertically" style={{width: "100%", height: "80%"}}>
                    <p className="front_side_card_read_only_title"> {cardData.description} </p>
                </div>
            </div>
        </div>
        )
    }

    return (
        <div className="card_read_only" >
            <img className="front_side_card_read_only_image" src={frontSideAction} alt="front side action" />
            <div className="strength_front_side_card_read_only_content">
                <div className="full_screen center_horizontally_and_vertically">
                    <p className="front_side_card_read_only_title">{cardData.description}</p>
                </div>
            </div>
        </div>
    );
}

export default StrengthCardReadOnly;